import { computed } from "vue";

export function useSidebarBackground() {
  const sidebarBackgroundClass = computed(() => {
    return import.meta.env.VITE_MODE === "production"
      ? "bg-slate-700"
      : "bg-[#0376bb]";
  });

  const sidebarHoverActiveClass = computed(() => {
    return import.meta.env.VITE_MODE === "production"
      ? "hover:bg-slate-500"
      : "hover:bg-[#4b72c1]";
  });

  const sidebarActiveClass = computed(() => {
    return import.meta.env.VITE_MODE === "production"
      ? "bg-slate-500"
      : "bg-[#746bc0]";
  });

  const sidebarMenuItemClass = computed(() => {
    return import.meta.env.VITE_MODE === "production"
      ? "bg-slate-600"
      : "bg-[#9762b8]";
  });

  return {
    sidebarBackgroundClass,
    sidebarHoverActiveClass,
    sidebarActiveClass,
    sidebarMenuItemClass,
  };
}
